import { useContext, useState } from "react";
import { DataContext } from "../../utils/contexts";
import { exportPdf } from "utils";
import { ExportExcelAdjustment } from "./ExportExcelAdjusment";
import { ExportPdfAdjustment } from "./ExportPdfAdjusment";
import { useListExportNew } from "pages/Inventori/Transaction/AddNewItem/utils";
import { ListType } from "../types";
import ModalConfirmExport from "../../components/ModalConfirmExport";

export function ModalExportAdjusment(props: {
    type: "excel" | "pdf" | string,
    setIsOpen: React.Dispatch<React.SetStateAction<{ isOpen: boolean; type: string, activeTab: string | null }>>
}) {
    const [amount, setAmount] = useState<number>(10)
    const { fill, activeColumn } = useContext(DataContext)

    const { data } = useListExportNew("adjusment", {
        start_date: fill.dateFrom,
        end_date: fill.dateTo,
        approved: fill.approval_status,
        location_id: fill.location_id,
        source: fill.source,
        jumlah_item: amount
    })

    return (
        <ModalConfirmExport
            isOpen={true}
            setIsOpen={props.setIsOpen}
            amount={amount}
            setAmount={setAmount}
            title="Item Adjustment"
            type={props.type as "excel" | "pdf"}
            total={data.total_record}
            onExport={(amount) => {
                if (props.type === "excel") {
                    ExportExcelAdjustment({
                        data: data.items as ListType[],
                        filter: {
                            dateFrom: fill.dateFrom,
                            dateTo: fill.dateTo
                        },
                        module: "INVENTORY",
                        title: "REGISTER ADJUSTMENT",
                        fileName: "register_adjustment",
                        activeColumns: activeColumn!
                    });
                }

                if (props.type === "pdf") {
                    const documentComponent = (
                        <ExportPdfAdjustment data={data.items as ListType[]} filter={fill} tableActive={activeColumn!} />
                    )
                    exportPdf({ documentComponent, fileName: "register_adjustment" })
                }
            }}
        />
    )
}